import { mapState, mapActions } from 'vuex'

import { getArrayOfIntFromQueryParams } from '../utils/array'

export default {
  data() {
    return {
      filterValues: {
        name: this.$route.query.name || '',
        ageRangeIds: parseInt(this.$route.query.ageRangeIds) || null,
        categoryId: parseInt(this.$route.query.categoryId) || null,
        skillId: parseInt(this.$route.query.skillId) || null,
        ODSId: parseInt(this.$route.query.ODSId) || null,
        language: this.$route.query.language || null,
        subjectIds: getArrayOfIntFromQueryParams(this.$route.query, 'subjectIds') || [],
        resourceTypes: getArrayOfIntFromQueryParams(this.$route.query, 'resourceTypes') || [],
        necessaryMaterials: getArrayOfIntFromQueryParams(this.$route.query, 'necessaryMaterials') || [],
        implementationType: getArrayOfIntFromQueryParams(this.$route.query, 'implementationType') || [],
        author: parseInt(this.$route.query.author) || null
      }
    }
  },
  computed: {
    ...mapState({
      showAdvancedFilters: state => state.behavior.advancedFilters.show
    })
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement'
    ]),
    updateFilterValue(field, value) {
      this.filterValues[field] = value
    },
    handleFiltersModalStatus() {
      const handleStatus = this.showAdvancedFilters ? this.hideElement : this.showElement
      handleStatus({ element: 'advancedFilters' })
    },
    closeFiltersModal() {
      this.hideElement({ element: 'advancedFilters' })
    },
    clearAdvancedFilters() {
      this.filterValues.subjectIds = []
      this.filterValues.resourceTypes = []
      this.filterValues.necessaryMaterials = []
      this.filterValues.implementationType = []
    }
  }
}
